<template>
	<div class="customer-list-wrapper">
		<div class="customer-table">
			<table id="datatable" v-if="asyncDone" class="table table-striped table-bordered"
				cellspacing="0" width="100%">
				<thead>
					<tr>
						<th>Owner Name</th>
						<th>Owner Email</th>
						<th>Created</th>
						<th class="disabled-sorting text-right">Actions</th>
					</tr>
				</thead>
				<tfoot>
					<tr>
						<th>Owner Name</th>
						<th>Owner Email</th>
						<th>Created</th>
						<th class="disabled-sorting text-right">Actions</th>
					</tr>
				</tfoot>
				<tbody>
					<tr v-for="customer in collaborators" :key="customer.docID">
						<td>{{ customer.supervisorName }}</td>
						<td>{{ customer.supervisorEmail }}</td>
						<td class="sort-date">{{ customer.created | formatDate }}</td>
						<td class="text-center">
							<router-link v-if="customer.status !== 'pending'" tag="button" class="btn text-light btn-link bg-primary btn-sm ml-3"
									:to="{ name: 'CollaboratorSites', params: { userId: customer.supervisorId } }">
								Collaborate
							</router-link>
							<button v-else class="btn text-light btn-link bg-primary btn-sm ml-3" @click="acceptCollaboration(customer)">Accept This Collaboration</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>


<script>
	import {db, functions} from "@/firebase/init";
	import loginAsMixin from "../../../mixins/loginAsMixin";
	import dateMixin from "../../../mixins/dateMixin";
	import swal from 'sweetalert2';

	export default {
		name: "CollaboratorList",
		mixins: [loginAsMixin, dateMixin],
		data() {
			return {
				editCollaborator: {},
				collaborators: [],
				noUser: false
			};
		},
		computed: {
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			user() {
				return this.$store.getters.user;
			},
			userToken() {
				return this.$store.getters.getUserToken;
			}
		},
		methods: {
			list() {
				this.collaborators = [];
				db.collection('users').doc(this.user.uid).get().then((doc) => {
					this.collaborators = doc.data()['supervisors'];
				});
			},
			async acceptCollaboration(selectionSupervisor) {
				try{
					swal({
						title: "Accepting Collaboration",
						text: "Are you sure to accept this collaboration?",
						type: "question",
						confirmButtonText: "Yes Proceed",
						confirmButtonColor: "#6ACF98",
						showCancelButton: true,
						cancelButtonText: "No Thanks",
						cancelButtonColor: "#EE8057"
					}).then(async result => {
						if(result.value){
							selectionSupervisor.status = 'accepted';
							await db.collection('users').doc(this.user.uid).update({
								supervisors: this.collaborators
							});
							const supervisorRef = await db.collection('users').doc(selectionSupervisor.supervisorId).get();
							const allCollaboratorsOfSupervisor = supervisorRef.data()['collaborators'];
							for(const collaborator of allCollaboratorsOfSupervisor){
								if(collaborator.email === this.user.email){
									collaborator.status = 'accepted';
									break;
								}
							}
							await db.collection('users').doc(selectionSupervisor.supervisorId).update({
								collaborators: allCollaboratorsOfSupervisor
							});
							swal('Accepted', 'You can now collaborate', 'success');
						}
					});
				}catch (e) {
					console.error(e);
					swal('Error', 'Error in accepting this collaboration', 'error');
				}

			},
			delete(docID) {
				if (
					confirm(
						"Are you certain that you want to delete this user? This process cannot be undone."
					)
				) {
					// Set asyncDone to false
					this.$store.dispatch("async/stateUpdate", {state: false});

					// Connect with firebase cloud functions and pass the docID as a data parameter to delete the user from the system
					const deleteUser = functions.httpsCallable("deleteUser");
					deleteUser({
						uid: docID
					})
						.then(result => {
							if (result.data.message === "success") {
								this.$store.dispatch("async/stateUpdate", {state: false});

								this.getAdmins({
									type: "success",
									message:
										"The user has successfully been deleted from the system.",
									show: true
								});

								this.$store.dispatch("async/stateUpdate", {state: true});
							}
						})
						.catch(err => {
							// Show error message to the user for 5 sec
							this.$store.dispatch("alert/update", {
								type: "danger",
								message: err,
								show: true
							});

							setTimeout(() => {
								this.$store.dispatch("alert/showUpdate", {show: false});
							}, 5000);
						});
				}
			}
		},
		created() {
			this.list();
		},
		mounted() {
			/* eslint-disable */
			$('#editCollaborator').on('hide.bs.modal', () => {
				this.editCollaborator = {};
			});
			/* eslint-enable */
		},
		updated() {
			const deleteuser = this.delete
			/* eslint-disable */
			$("#datatable").on("click", ".remove", function () {
				const docID = $(this).attr("data");
				deleteuser(docID)
			});
			/* eslint-enable */
		}
	};
</script>
